<template>
  <router-link
    :to="{
      name: 'invoices.show',
      params: { invoice_id: invoice.id },
    }"
    :class="{ 'pending-row': isPending }"
  >
    <div class="row">
      <div class="col-12 col-lg-3 col-xl-3">
        <p class="text-wrap">
          <span class="data-label d-lg-none">Invoice #:</span>
          <a v-if="invoice.type === 'retainer' && invoice.xero_id" :href="'https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=' + invoice.xero_id" target="_blank" class="strong" @click.stop>{{ invoice.xero_number }}</a>
          <span v-else-if="invoice.opportunity_number" class="strong">{{ invoice.opportunity_number }}</span>
          <span v-else class="strong">{{ invoice.reference }}</span>
          <br v-if="(invoice.type === 'retainer' && invoice.xero_id && invoice.reference) || invoice.instalment_description" />
          <small v-if="invoice.type === 'retainer' && invoice.xero_id && invoice.reference" class="text-muted">{{ invoice.reference }}</small>
          <small v-else-if="invoice.instalment_description" class="text-muted">{{ invoice.instalment_description }}</small>
        </p>
      </div>

      <div class="col-6 col-lg-2 col-xl-2">
        <p>
          <span class="data-label d-lg-none">Type:</span>
          <span
            class="status"
            :class="invoice.type === 'retainer' ? 'status-primary' : 'status-info'"
          >{{ invoice.type === 'retainer' ? 'Retainer' : 'Project' }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p>
          <span class="data-label d-lg-none">Due:</span>
          <span>{{ invoice.due | moment('DD/MM/YYYY') }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <p>
          <span class="data-label d-lg-none">Status:</span>
          <span
            v-bind:class="displayStatus == 'PAID' ? 'status-success' : 'status-mute'"
            class="status"
            >{{ displayStatus }}</span
          >
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Total:</span>
          <span :class="isPending ? 'text-muted' : (invoice.type === 'retainer' ? 'text-success' : 'text-danger')">{{ invoice.type === 'retainer' ? '+' : '-' }}$ {{ invoice.total | currency }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Balance:</span>
          <span v-if="!isPending" :class="balance < 0 ? 'text-danger' : ''">$ {{ balance | currency }}</span>
          <span v-else class="text-muted">-</span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    invoice: {
      required: true,
      type: Object,
    },
    balance: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  computed: {
    isPending() {
      return this.invoice.type !== 'retainer' && this.invoice.status === 'DRAFT';
    },
    displayStatus() {
      if (this.isPending) {
        return 'PENDING';
      }
      return this.invoice.status;
    },
  }
};
</script>

<style scoped>
.pending-row {
  background-color: #f8f9fa;
  opacity: 0.7;
}
</style>
